<div class="container">
  <h2>{{ 'HeaderComponent-WHY_SR' | translate }}</h2>
  <img class="responsive-img z-depth-2" src="{{ image }}" *ngFor="let image of introImages" />
</div>
